import { ActivatedRoute, Router } from '@angular/router';
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhatsappShareComponent } from '@common-components/whatsapp-share/whatsapp-share.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PremiumServicePitchPageComponent } from '@common-components/premium-service-pitch-page/premium-service-pitch-page.component';
import { EventsService } from '@services/events/events.service';
import { FundraiserService } from '@services/fundraiser/fundraiser.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { IBasicInfo, IFundraiser } from '@models/fundraiser.model';
import { StorageService } from '@services/storage/storage.service';

@Component({
  selector: 'app-campaign-create-thankyou',
  standalone: true,
  imports: [
    CommonModule,
    WhatsappShareComponent,
    MatButtonModule,
    MatIconModule,
    PremiumServicePitchPageComponent
  ],
  templateUrl: './campaign-create-thankyou.component.html',
  styleUrls: ['./campaign-create-thankyou.component.scss']
})
export class CampaignCreateThankyouComponent {

  private actRoute = inject(ActivatedRoute);
  private events = inject(EventsService);
  private fundraiserService = inject(FundraiserService);
  private router = inject(Router);
  private readonly storage = inject(StorageService);
  private util = inject(UtilService);
  private vars = inject(VariablesService);

  campaignId;
  fundraiser: IFundraiser;
  basicInfo = {} as IBasicInfo;
  theme = 'v2';
  premiumPlanList = []

  isMedical:boolean= true;

  info = {
    congratsContent: {
      title: 'Congratulations Saurabh! Your fundraiser is live.',
      desc: 'Share your fundraiser today to get your first contribution and put your campaign on path to success.'
    },
    whatsappShareContent: {
      shareTitle: 'Share on Whatsapp',
      desc: 'We’ve even created a ready-to-send message just for you!'
    },
    planDetails: {
      header: {
        title: 'Let’s help you reach your goal',
        desc: 'Explore our different plans that can help you reach faster to your campaign goals'
      }
    }
  }

  ngOnInit() {
    this.vars.pageName = 'campaign_thank_you';
    this.actRoute.queryParams.subscribe(
      data => {
        if(data.custom_tag){
          this.getFundraiser(data.custom_tag);
        }
        if(data.type !== 'non-medical'){
          this.isMedical == false;
        }
      }
    );
    this.vars.layoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      animateHeader: false,
      headerTopSticky: false,
      zendesk: true
    });
    this.util.blitzEventHandler('Start Fund');
  }

  pageViewEvents() {
    const payload = {
      'page_url': `${this.vars.domainData.url}/new/campaign-thank-you`,
      'event_type': 'campaign',
      'page_name': 'campaign_thank_you',
      'event_type_id': this.campaignId,
      'info_3': this.storage.get('language'),
      'eventName': 'pageView',
    };
    this.events.onLoadSystemEvent(payload);
  }

  getFundraiser(customTag) {
    const qParam = `?with=campaigner.social;basicinfo;beneficiaryrelation&show_services=true&showError=false`;
    this.fundraiserService.getCampaign(customTag, qParam).subscribe((res: any) => {
      this.fundraiser = res.data;
      this.campaignId = this.fundraiser.id;
      this.setBasicInfo(res.data.basicinfo);
      this.setPremiumServices(res.data);
      this.vars.fundraiser = res.data;
      this.pageViewEvents();
    });
  }

  setPremiumServices(data) {
    if (data.plan) {
      this.vars.activeKettoPremiumPlanData = data.plan;
    }
    if (data && data.hasOwnProperty('premium_plans') && data.premium_plans && data.premium_plans.length > 0) {
      const arr = [];
      data.premium_plans.forEach(element => {
        const benefits = element.benefits;
        const eligibleLength = benefits?.eligible?.length || 0;

        const includes = [];

        benefits?.eligible?.forEach((item, idx) => {
          includes.push({
            id: idx,
            title: item,
            isChecked: true
          });
        });

        benefits?.not_eligible?.forEach((item, idx) => {
          includes.push({
            id: eligibleLength + idx,
            title: item,
            isChecked: false
          });
        });

        arr.push({
          isCurrentPlan: this.vars.activeKettoPremiumPlanData?.info_1 === element?.plan_name ? true : element?.plan_name === 'bronze',
          planDetails: element.title,
          planBtnLabel: `${this.vars.activeKettoPremiumPlanData ? (this.vars.activeKettoPremiumPlanData?.info_1 === element?.plan_name ? 'Current Plan' : 'Upgrade to ' + this.util.toTitleCase(element?.plan_name)) : this.util.toTitleCase(element.plan_name) === 'bronze' ? 'Current Plan' : 'Upgrade to ' + this.util.toTitleCase(element?.plan_name)}`,
          planName: element.plan_name,
          selected: !!element.selected,
          planPrice: this.getPlanPrice(element),
          includes,
          isRecommended: element?.recommend
        });
      });
      this.premiumPlanList = [...arr];
    }
  }

  getPlanPrice(element) {
    const choice = {
      0: 'Free',
      5: '5% <span>Platform Fees*</span>',
      7: '7% <span>Platform Fees*</span>'
    }
    return choice[element.platform_fee];
  }
  /**Set Basic Info */
  setBasicInfo(data: any[]) {
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1 || '';
      }
      this.vars.basicInfo = this.basicInfo;
    }
  }

  goToFundraiser() {
    const payload = {
      'eventName': 'skip_to_fundraiser',
      'event_type': 'campaign',
      'page_name': 'campaign_thank_you',
      'event_type_id': this.campaignId
    };
    this.events.sendSystemEvent(payload).subscribe(
      () => {
        this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
      },
      (err) => {
        this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
      }
    );
  }

  ngOnDestroy() {
  }

}
